"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.minBy = exports.min = void 0;

var _pipe = require("../pipe/pipe");

var _curry = require("../curry/curry");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _minBy = function _minBy(_fn, source) {
  var fn = Array.isArray(_fn) ? _pipe.pipe.apply(void 0, _toConsumableArray(_fn)) : _fn;

  if (source.length === 0) {
    return undefined;
  }

  var result = {
    item: source[0],
    value: fn.call(null, source[0])
  };

  for (var i = 1, length = source.length; i < length; i++) {
    if (result.value > fn.call(null, source[i])) {
      result.item = source[i];
      result.value = fn.call(null, result.item);
    }
  }

  return result.item;
};
/**
 * Find the minimum value in a source array
 *
 * @param  {Number[]} source Array of numbers
 *
 * @return {Number}
 *
 * @name min
 * @tag Array
 * @signature ( source: Number[] ): Number
 * @signature ( fn: Function ) => ( source: Number[] ): Number
 *
 * @example
 * min([-1, 1, 10, 3])
 * // => -1
 *
 * const fn = element => ( new Date( element.time ) )
 * const source = [
 *   { time: "2018-05-15T11:20:07.754110Z" },
 *   { time: "2018-06-11T09:01:54.337344Z" },
 *   { time: "2018-06-08T08:26:12.711071Z" },
 * ]
 * min(fn)(source)
 * // => {time: "2018-05-15T11:20:07.754110Z"}
 */


var min = function min(source) {
  if (source.length === 0) {
    return undefined;
  }

  var _source = _slicedToArray(source, 1),
      result = _source[0];

  for (var i = 0, length = source.length; i < length; i++) {
    if (result > source[i]) {
      result = source[i];
    }
  }

  return result;
};

exports.min = min;
var minBy = (0, _curry.curry)(_minBy);
exports.minBy = minBy;